module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VG1002-ce22e4fdea20df2b0c13e9547b3cf438.png";